<template>
  <div class="login-form">
    <v-form
      ref="formRef"
      @submit.prevent="$emit('submit')"
    >
      <div class="login-form__field">
        <label class="login-form__label" for="login-email">Work email</label>
        <v-text-field
          id="login-email"
          :model-value="email"
          placeholder="you@company.com"
          prepend-inner-icon="mdi-email-outline"
          variant="outlined"
          density="comfortable"
          hide-details="auto"
          :rules="rules"
          :disabled="disabled"
          class="login-form__input"
          autocomplete="email"
          aria-required="true"
          @update:model-value="$emit('update:email', $event)"
          @keyup.enter="$emit('submit')"
        />
      </div>
    </v-form>

    <button
      type="button"
      class="login-btn login-btn--primary"
      :disabled="disabled || !email || loading"
      :aria-busy="loading"
      @click="$emit('submit')"
    >
      <v-icon icon="mdi-shield-key-outline" class="login-btn__icon" />
      Send Verification Code
    </button>
  </div>
</template>

<script setup>
import { ref } from 'vue'

defineOptions({ name: 'LoginEmailStep' })

defineProps({
  email: {
    type: String,
    default: '',
  },
  rules: {
    type: Array,
    default: () => [],
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['update:email', 'submit'])

const formRef = ref(null)

defineExpose({ formRef })
</script>
